function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';

var FullScreenModal = function (_React$Component) {
  _inherits(FullScreenModal, _React$Component);

  function FullScreenModal() {
    var _temp, _this, _ret;

    _classCallCheck(this, FullScreenModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.goToPreviousOnESC = function (event) {
      if (event.keyCode === 27) {
        _this.props.goToPrevious();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FullScreenModal.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.goToPreviousOnESC, false);
  };

  FullScreenModal.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.goToPreviousOnESC, false);
  };

  FullScreenModal.prototype.render = function render() {
    var _props = this.props,
        goToPrevious = _props.goToPrevious,
        children = _props.children;
    return React.createElement('div', {
      className: 'dd-fullscreen-modal show'
    }, React.createElement('div', {
      className: 'dd-modal-content'
    }, React.createElement('div', {
      className: 'dd-modal-dialog'
    }, React.createElement('div', {
      className: 'dd-container'
    }, React.createElement('div', {
      onClick: function onClick() {
        return goToPrevious();
      },
      className: 'dd-modal-close'
    }), React.createElement('div', null, children)))));
  };

  return FullScreenModal;
}(React.Component);

export default FullScreenModal;